var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{ref:"addUserBody",staticClass:"add-user__body"},_vm._l((_vm.reversedCoreTasks),function(task){return _c('div',{key:task.id,staticClass:"tags mt-3"},[_vm._v(" "+_vm._s(task.text)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }